import { Route, Routes } from 'react-router-dom';

import DatafySwitchProvider from '~/shared/context/DatafySwitchProvider';

import ExplorationPage from './ExplorationPage';

export default function ExplorationRoutes() {
  return (
    <DatafySwitchProvider>
      <Routes>
        <Route index element={<ExplorationPage />} />
      </Routes>
    </DatafySwitchProvider>
  );
}
